import React, { Component } from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { dateFormatWithTime, dayAgo } from "../../helper";
import { PATHS, MEETING_OPTION } from "../../constant";
import { get } from "lodash";
import { PragatiCardInfo } from "./pragatiCardInfo";
import PermissionHOC from "../PermissionHOC";
import { getAgendaStakeHolderAction } from "../../actions/mom.action";
import { ReadMore } from "../reusableComponent/readMore";
import MeetingModeIcon from "../../assets/meeting-mode-icon.svg";
import {
  getLocalstorage,
  dateFormat,
  getDayOfTheGivenDate,
  getTimeOfTheGivenDate,
  getAgendaTagsColor
} from "../../helper";
import ChairedBy from "../../assets/created-by.svg";

class PragatiCard extends Component {
  state = {
    openSummary: false
  };

  onToggleSummary = event => {
    event && event.preventDefault();
    this.setState(prevState => ({ openSummary: !prevState.openSummary }));
  };

  getAgendaStackeHolder = async () => {
    const { agendaListDto } = this.props;
    return await getAgendaStakeHolderAction(undefined, agendaListDto);
  };
  truncateWithEllipsis(str, maxLength) {
    if (str.length <= maxLength) {
      return str;
    }
    return str.slice(0, maxLength - 3) + "..."; // Truncate to maxLength-3 and add "..."
  }

  render() {
    const { openSummary } = this.state;
    const { onToggleSummary } = this;
    const { pragatiDetails } = this.props;
    //console.log(pragatiDetails)
    let meetingOm = get(pragatiDetails, "fileDTOList", []);
    const URL =
      pragatiDetails && pragatiDetails.meetingStatus === "DRAFT"
        ? PATHS.CREATE_AGENDA
        : PATHS.AGENDA_DETAILS;
    const user = getLocalstorage("user");
    const groupCategory = getLocalstorage("groupCategory");
    return (
      <React.Fragment>
        {openSummary ? (
          <PragatiCardInfo
            pragatiDetails={pragatiDetails}
            onClose={onToggleSummary}
          />
        ) : (
          <React.Fragment />
        )}

        <a
        //  to={{
        //   pathname: PATHS.PRAGATI_DETAILS_PAGE,
        //   search: `?agendaId=${get(pragatiDetails, "id", "NA")}`,
        //   state: {
        //     agendaId: pragatiDetails && pragatiDetails.id
        //   }
        // }}
        >
          <Container
            fluid
            className="agenda-card"
            style={{
              width: "96%",
              paddingRight: 2,
              paddingLeft: 15,
              paddingBottom: 10
            }}
          >
            <Row className="agenda-row pragati">
              <Col
                className="agenda agenda-col-1"
                style={{
                  cursor: "auto",
                  boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.25)"
                }}
              >
                <div className="agenda-cards-alignment">
                  <div>
                    <div className="agenda-details mb-2 align-items-center">
                      <div className="agenda-list-title">
                        AGENDA ID{" "}
                        {groupCategory == "PMG" ? (
                          <>
                            <Link
                              to={{
                                pathname: URL,
                                search: `?agendaId=${get(
                                  pragatiDetails,
                                  "id",
                                  "NA"
                                )}`,
                                state: {
                                  agendaId: pragatiDetails && pragatiDetails.id
                                }
                              }}
                              className="agenda-id"
                            >
                              #{pragatiDetails && pragatiDetails.id}
                            </Link>
                          </>
                        ) : (
                          <>
                            <span className="agenda-id">
                              #{pragatiDetails && pragatiDetails.id}
                            </span>
                          </>
                        )}{" "}
                        |{" "}
                        <span className="agenda-total">
                          {pragatiDetails && pragatiDetails.projectCount}{" "}
                          Project(s) &{" "}
                          {pragatiDetails && pragatiDetails.issueCount} Issue(s)
                        </span>
                      </div>

                      <div>
                        <div
                          className={`${getAgendaTagsColor(
                            pragatiDetails.meetingStatus
                          )} ${
                            pragatiDetails.meetingStatus === "DRAFT"
                              ? "draft-agenda-btn"
                              : ""
                          } agenda-stage`}
                        >
                          <div
                            className={`agenda-stage-background ${
                              pragatiDetails.meetingStatus === "DRAFT"
                                ? "draft-agenda-text"
                                : ""
                            }`}
                          >
                            {pragatiDetails.meetingStatus}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="agenda-details">
                      <div className="agenda-list-title">
                        <h3 className="agenda-title mb-4">
                          <Link
                            style={{
                              textDecoration: "none",
                              color: "#000",
                              verticalAlign: pragatiDetails.agendaName.match(
                                /[\u0900-\u097F]/
                              )
                                ? "sub"
                                : ""
                            }}
                            to={{
                              pathname: PATHS.PRAGATI_DETAILS_PAGE,
                              search: `?agendaId=${get(
                                pragatiDetails,
                                "id",
                                "NA"
                              )}`,
                              state: {
                                agendaId: pragatiDetails && pragatiDetails.id
                              }
                            }}
                          >
                            {pragatiDetails && pragatiDetails.agendaName}
                          </Link>
                        </h3>
                      </div>
                    </div>
                    <div className="flex-style">
                      <div className="meeting-info pragati meeting-when pragati-list-card">
                        <span className="info-in-agenda-detail">
                          <b className="heading-in-agenda-details">When</b>
                          {getDayOfTheGivenDate(pragatiDetails.meetingDate) +
                            ", " +
                            dateFormat(get(pragatiDetails, "meetingDate"))}
                          ,{" "}
                          {pragatiDetails.meetingTimeFrom !== null &&
                            pragatiDetails.meetingTimeFrom !== 0 &&
                            getTimeOfTheGivenDate(
                              pragatiDetails.meetingTimeFrom
                            )}
                        </span>
                      </div>
                      <div
                        className="meeting-info pragati-venue"
                        style={{ width: "82%" }}
                      >
                        <span className="info-in-agenda-detail">
                          <b className="heading-in-agenda-details">
                            Meeting Mode
                          </b>

                          {pragatiDetails.meetingMode == null ? (
                            <>NA</>
                          ) : (
                            <>
                              {pragatiDetails.meetingMode
                                .toLowerCase()
                                .replace(/_/g, " ")
                                .replace(/(?: |\b)(\w)/g, function(key, p1) {
                                  return key.toUpperCase();
                                })}
                            </>
                          )}
                        </span>
                      </div>
                    </div>

                    <div
                      className="flex-style"
                      style={{ gap: "2%", marginTop: 20 }}
                    >
                      <div className="meeting-info pragati-meeting-type">
                        <span className="info-in-agenda-detail">
                          <b className="heading-in-agenda-details ">
                            Meeting OM
                          </b>
                          <label
                            class="meeting-om-attachment"
                            style={{
                              cursor:
                                meetingOm.length === 0 ? "auto" : "pointer"
                            }}
                          >
                            {meetingOm.length === 0 ? (
                              <>--</>
                            ) : (
                              <>
                                <a
                                  className="om_attachment_link"
                                  target="_blank"
                                  href={meetingOm[0].s3Url}
                                  style={{ color: "#18499C", fontWeight: 600 }}
                                >
                                  {this.truncateWithEllipsis(
                                    meetingOm[0].name.substring(
                                      0,
                                      meetingOm[0].name.lastIndexOf(".")
                                    ),
                                    32
                                  )}
                                </a>
                                <div class="attachment-added-tooltip-om pragati">
                                  <div
                                    class="project-download-icons"
                                    style={{ marginBottom: 0, marginRight: 0 }}
                                  >
                                    <div class="download-icons-pdf">
                                      {meetingOm[0].name
                                        .substr(
                                          meetingOm[0].name.lastIndexOf(".") +
                                            1,
                                          meetingOm[0].name.length
                                        )
                                        .toLowerCase()}
                                    </div>
                                    <a
                                      target="_blank"
                                      href={meetingOm[0].s3Url}
                                      download={meetingOm[0].s3Url}
                                      rel="noopener noreferrer"
                                      style={{
                                        paddingLeft: 6,
                                        paddingRight: 0,
                                        textDecoration: "none"
                                      }}
                                    >
                                      {meetingOm[0].name}
                                    </a>
                                  </div>
                                </div>
                              </>
                            )}
                          </label>

                          {/* {(pragatiDetails && pragatiDetails.meetingType) || "NA"} */}
                        </span>
                      </div>
                      <div className="flex-width d-flex agenda-card-chairedby">
                        <span>
                          <Image src={ChairedBy} />
                        </span>
                        <div>
                          <span className="info-in-agenda-detail">
                            <b className="heading-in-agenda-details">
                              Chaired By
                            </b>{" "}
                            <br />
                            {pragatiDetails && pragatiDetails.meetingChairedBy}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      className="flex-style summary"
                      style={{ paddingTop: 0, cursor: "pointer" }}
                    >
                      <a
                        onClick={e => {
                          onToggleSummary(e);
                        }}
                      >
                        Agenda Summary
                        <hr className="agenda-summary-line" />
                      </a>
                    </div>

                    <div className="agenda-created-on">
                      Updated on{" "}
                      <span>
                        {getDayOfTheGivenDate(pragatiDetails.updatedDate) +
                          ", " +
                          dateFormat(pragatiDetails.updatedDate) +
                          ", " +
                          getTimeOfTheGivenDate(pragatiDetails.updatedDate)}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </a>
      </React.Fragment>
    );
  }
}

export default PermissionHOC(PragatiCard);
